/* eslint-disable */
import React from 'react';
import { Construction } from 'lucide-react';

export default function PlaceholderPage({ title, description }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 400 }}>
      <div style={{
        width: 72, height: 72, borderRadius: 20,
        background: 'linear-gradient(135deg, #f0f4f8, #e2e8f0)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 20,
      }}>
        <Construction size={32} color="#94a3b8" />
      </div>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 8px' }}>{title}</h2>
      <p style={{ fontSize: 14, color: '#64748b', maxWidth: 360, textAlign: 'center', lineHeight: 1.6 }}>
        {description || 'This section is under construction. Check back soon!'}
      </p>
    </div>
  );
}
